import { formatPrice } from "./utils/format-price.js";
import { formatLabel } from "./utils/format-label.js";
import { MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH, getConcatClickTrackingAttributes } from "./utils/get-concat-click-tracking-attributes.js";
import { mapProductStockToProductStatus } from "./utils/map-product-stock-to-product-status.js";
import { mapProductTypeToProductCategory } from "./utils/map-product-type-to-product-category.js";
export {
  MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH,
  formatLabel,
  formatPrice,
  getConcatClickTrackingAttributes,
  mapProductStockToProductStatus,
  mapProductTypeToProductCategory
};
//# sourceMappingURL=utils.js.map
